import service from '@/utils/server';

const modName='/bd/qcSpot/';
export const pageInfo = data => {
  return service({
    url: modName + 'getQcSpotPageInfo',
    method: 'post',
    data
  });
};

//开始抽检
export const executeQcSpot = data => {
  return service({
    url: modName + 'executeQcSpot',
    method: 'post',
    data
  });
};

//取消抽检
export const cancel = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/qc/qcSpot/api/index.js